/* We are disabling the Text editing in some of the variables. We get to this eventually once
understood that it would be too complex to keep phones, businessHours, addresses, and emails
editable, since those are represented in the site settings dialog with the help of complex UI.
That means that we would have to implement a complex parsing/validation system in order to allow
both manual editing of those variable via direct text editing and keep that complex UI, which is
too much for us now.
*/

import isEmpty from 'lodash.isempty';

import hdrm from '../../hdrm';
import globals from '../../globals';
import getVariables from '../../template/selectors/variables';
import { connectedStore } from '../../store';

const disableVariablesTextEditing = (element) => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = getVariables(state);
  const editableElements = new Map();

  if (isEmpty(variables)) return element;

  Object.keys(variables).forEach((variable) => {
    variables[variable].forEach((instance) => {
      const global = globals.selectors.getGlobal(state, instance.globalId);
      const variableInstances = [
        ...element.querySelectorAll(
          `${globals.constants.GLOBAL_TAG_NAME}[src*="${global.id}"] ${instance.querySelector}`
        ),
      ];
      const variableElements = variableInstances.reduce((acc, el) => {
        const instances = [
          el,
          ...el.querySelectorAll(`[${hdrm.injections.bindings.text.TEXT_ATTRIBUTE}]`),
        ];
        return acc.concat(instances);
      }, []);

      variableElements.forEach((el) => {
        if (instance.enableTextEditing && editableElements.has(el)) {
          editableElements.set(el, false);
        } else if (!instance.enableTextEditing && !editableElements.has(el)) {
          editableElements.set(el, true);
        }
      });
    });
  });

  editableElements.forEach((value, key) => {
    if (value) {
      hdrm.injections.bindings.text.remove(key);
    }
  });

  return element;
};

export default disableVariablesTextEditing;
